import {
  Button,
  Column,
  Copy,
  Flex,
  Row,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { LocTagInvite } from 'src/types/LineOfCredit';
import { GroupLocTableItemContainer } from 'src/components/selfService/features/LineOfCredit/details/Groups/GroupLocTableItemContainer';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export interface IGroupLocTableItemProps {
  group: LocTagInvite;
  checked: boolean;
  dinerCount: number;
  onCheckboxChange: (groupId: string) => void;
  onGroupRemove: (groupId: string) => void;
}

export default function GroupLocTableItem({
  group,
  checked,
  dinerCount,
  onCheckboxChange,
  onGroupRemove,
}: IGroupLocTableItemProps): JSX.Element {
  const { isDesktop, isPhone } = useScreenSizes();

  return (
    <GroupLocTableItemContainer isPhone={isPhone}>
      <Flex>
        <Stack x="x-sm">
          <Checkbox
            id={`select-${group.id}`}
            name={`select-${group.id}`}
            ariaLabel={`select-${group.id}`}
            cancelLabelBottomMargin
            checked={checked}
            onChange={() => onCheckboxChange(group.id)}
          />
        </Stack>
        <Stack flex={1}>
          <Row alignItems="flex-start">
            <Column phone={9}>
              <Row>
                <Column desktop={4}>
                  <Flex alignItems="center" height="100%">
                    <Stack className="ellipsisOverflow">
                      <Copy variant="body">{group.name}</Copy>
                    </Stack>
                  </Flex>
                </Column>
                <Column desktop={8}>
                  {isDesktop ? (
                    dinerCount
                  ) : (
                    <Copy variant="caption" color="secondaryText">
                      {`${dinerCount} ${
                        dinerCount === 1 ? 'person' : 'people'
                      }`}
                    </Copy>
                  )}
                </Column>
              </Row>
            </Column>
            <Column phone={3}>
              <Row justifyContent="flex-end">
                <Button
                  variant="tertiary"
                  buttonSize="medium"
                  className="tableActionButtons"
                  onClick={() => onGroupRemove(group.id)}
                  aria-label={`Unassign ${group.name}`}
                >
                  {isDesktop ? (
                    'Unassign'
                  ) : (
                    <SvgX size="24px" aria-label="Unassign" />
                  )}
                </Button>
              </Row>
            </Column>
          </Row>
        </Stack>
      </Flex>
    </GroupLocTableItemContainer>
  );
}
